import Glide from '@glidejs/glide';
import Sizes from '../../shared/glide_fixed_width_slides';
import { initializeArticleSlider } from '@/components/shared/articles-slider';

/**
 * Also Searched Slider
 */

const alsoSearchedSliderEl = document.querySelector('.also-searched-slider');
const alsoSearchedSliderConfig = {
  type: 'carousel',
  perView: 3,
  gap: 24,
  peek: {
    before: 5,
    after: 5,
  },
  breakpoints: {
    768: {
      perView: 1.2,
    },
    1000: {
      perView: 1.7,
      peek: {
        before: 28,
        after: 5,
      },
    },
  },
};

if (alsoSearchedSliderEl) {
  const alsoSearchedSlider = new Glide(
    alsoSearchedSliderEl,
    alsoSearchedSliderConfig,
  );

  alsoSearchedSlider.on('mount.after', () => {
    window.dispatchEvent(new Event('resize'));
  });
  alsoSearchedSlider.mount();
}

/**
 * Reviews slider
 */

const reviewsSliderSelector = '.patient-reviews__review-slider';
const reviewsSliderEl = document.querySelector(reviewsSliderSelector);
if (reviewsSliderEl) {
  const reviewsSlider = new Glide(reviewsSliderSelector, {
    perView: 1.8,
    gap: 20,
    slideWidth: 410,
    peek: {
      before: 0,
      after: 40,
    },
    breakpoints: {
      650: {
        perView: 1.1,
        gap: 10,
        slideWidth: 304,
        peek: {
          before: 0,
          after: 20,
        },
      },
    },
  });
  reviewsSlider.on('mount.after', () => {
    window.dispatchEvent(new Event('resize'));
  });
  reviewsSlider.mount({ Sizes });
}

/**
 * Five Star Review Slider
 * This is the same as the reviews slider, but with different breakpoints
 * Code pulled in from app/frontend/components/b2c/directory/fiveStarSlider.js
 */

const fiveStarSliderSelector = '.five-star-reviews.glide';
if (document.querySelector(fiveStarSliderSelector)) {
  const config = {
    type: 'carousel',
    perView: 3,
    gap: 20,
    peek: {
      before: 10,
      after: 10,
    },
    breakpoints: {
      500: {
        perView: 1.2,
        gap: 16,
        peek: {
          before: 16,
          after: 0,
        },
      },
      767: {
        perView: 1.5,
        gap: 25,
        peek: {
          before: 25,
          after: 0,
        },
      },
      1150: {
        perView: 1,
        gap: 50,
        peek: {
          before: 25,
          after: 25,
        },
      },
    },
  };

  if (document.body.classList.contains('faceted-search')) {
    config.breakpoints[1150].perView = 2;
    config.breakpoints[1150].gap = 25;
  }

  const fiveStarSlider = new Glide(fiveStarSliderSelector, config);
  fiveStarSlider.on('mount.after', () => {
    // This is needed to trigger the overflowExpandableController.
    // If we migrate to stimulus we can instead send the event directly to the controller
    window.dispatchEvent(new Event('resize'));
  });
  fiveStarSlider.mount();
}

// set up article slider

const articleSliderOptions = {
  type: 'carousel',
  startAt: 0,
  perView: 5,
  slideWidth: 248,
  gap: 6,
  peek: {
    before: 0,
    after: 8,
  },
  breakpoints: {
    1024: {
      perView: 3,
      peek: {
        before: 0,
        after: 40,
      },
    },
    650: {
      perView: 2,
      peek: {
        before: 0,
        after: 32,
      },
    },
    450: {
      perView: 1,
      peek: {
        before: 0,
        after: 32,
      },
    },
  },
};

const articleSliderSelector = '.directory-featured-articles.glide';
if (articleSliderSelector) {
  initializeArticleSlider(articleSliderSelector, articleSliderOptions);
}
